(function (jQuery) {

  jQuery.fn.isVisibleTop = function (offset) {
    const $window = jQuery(window);
    const $this = jQuery(this);
    const topView = $window.scrollTop();
    const botView = topView + $window.height();
    const topElement = $this.offset().top;

    return ((topElement <= botView + offset));
  }

  // Start animations when jQuery load
  jQuery('body').removeClass('preload');

  // Animatios for opacity and block-reveal
  jQuery.fn.setStartOnVisibleTop = function () {
    jQuery(this).each((index, element) => {
      const $element = jQuery(element);
      $element.toggleClass('start', $element.isVisibleTop(-20));
    });
  };

  const $startOnVisible = jQuery('.transition-opacity:not(.start), .transition-block-reveal:not(.start)');
  $startOnVisible.setStartOnVisibleTop();
  jQuery(window).on('scroll', () => {
    $startOnVisible.setStartOnVisibleTop();
  });

  // Animations for menu in home
  jQuery.fn.setViewMenuWindowTop = function () {
    const $window = jQuery(window);
    jQuery(this).each((index, element) => {
      const $element = jQuery(element);
      $element.toggleClass('view-menu', $element.isVisibleTop(-1.8 * $window.height()));
    });
  };

  const $bodyHome = jQuery('body.home');
  $bodyHome.setViewMenuWindowTop();
  jQuery(window).on('scroll', () => {
    $bodyHome.setViewMenuWindowTop();
  });
  

}(jQuery));